module.exports = __webpack_public_path__ + "static/media/Matcha.aa84c0ec.webp";